<template>
  <el-dialog width="1200px" title="Step Operation History" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <div class="pb20">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @submit.native.prevent="getDataList(1)">
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchStartToEndSecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start Date"
            end-placeholder="Ending Date"
            @change="getDataList(1)"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="pb20">
      <el-table border :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column align="center" label="Handling Time" width="164px">
          <template slot-scope="scope">
            {{ scope.row.handleAt | parseTimeSecond }}
          </template>
        </el-table-column>
        <el-table-column prop="handler.nickname" align="center" label="Handler" />
        <el-table-column prop="remark" align="center" label="Remark" />
        <el-table-column prop="attachmentUrls" align="center" label="Attachment">
          <template slot-scope="scope">
            <p v-for="item in scope.row.attachmentUrls" :key="item.url">
              <a :href="item.url" target="_target">{{ item.name }}</a>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="Status">
          <template slot-scope="scope">
            <p class="dot-Red" v-if="scope.row.status == 0">Not Pass</p>
            <p class="dot-Green" v-if="scope.row.status == 1">Pass</p>
            <p class="dot-Orange" v-if="scope.row.status == 2">Modified</p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import filtersMixin from "@/mixins/filtersMixin";
import searchMixin from "@/mixins/searchMixin";
export default {
  mixins: [paginationMixin, filtersMixin, searchMixin],
  components: { Pagination },
  props: {
    applymentId: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataForm: {
        step: "",
        startTime: "",
        endTime: "",
      },
      watchStartToEndSecondTimeRange: null,
    };
  },
  methods: {
    async init(data) {
      this.visible = true;
      await this.$nextTick();
      this.dataForm = {
        step: data,
        startTime: "",
        endTime: "",
      };
      this.getDataList(1);
    },
    // 获取分页
    getDataList(current) {
      setTimeout(async () => {
        this.dataListLoading = true;
        if (current) {
          this.current = current;
        }
        const { code, data } = await this.$http.get("/admin/companyApplymentStatusProcedureLog/paging", {
          params: {
            current: this.current,
            size: this.pageSize,
            "orders[0].asc": false,
            "orders[0].column": "id",
            applymentId: this.applymentId,
            step: this.dataForm.step,
            startTime: this.dataForm.startTime,
            endTime: this.dataForm.endTime,
          },
        });
        if (code === 200) {
          this.dataList = data.records;
          this.totalCount = data.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped></style>
